function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import PropTypes from 'prop-types';
import styled from 'styled-components';
import GridColumn from './GridColumn';
import { px2rem, getSpacing, getDisplay } from '../../utils/helpers';
var GridRow = styled.div(_templateObject(), function (_ref) {
  var _ref2;

  var theme = _ref.theme,
      hasGutters = _ref.gutters,
      align = _ref.align;
  var breakpoints = theme.breakpoints,
      grid = theme.grid;
  var gutters = grid.gutters;
  return _ref2 = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginRight: hasGutters && px2rem(-gutters / 2),
    marginLeft: hasGutters && px2rem(-gutters / 2),
    alignItems: align !== undefined && align.xs
  }, _ref2["& > " + GridColumn] = {
    paddingRight: !hasGutters ? 0 : undefined,
    paddingLeft: !hasGutters ? 0 : undefined
  }, _ref2["@media (min-width: " + breakpoints.small + "px)"] = {
    alignItems: align !== undefined && align.s
  }, _ref2["@media (min-width: " + breakpoints.medium + "px)"] = {
    alignItems: align !== undefined && align.m
  }, _ref2["@media (min-width: " + breakpoints.large + "px)"] = {
    alignItems: align !== undefined && align.l
  }, _ref2["@media (min-width: " + breakpoints.xlarge + "px)"] = {
    alignItems: align !== undefined && align.xl
  }, _ref2["@media (min-width: " + breakpoints.xxlarge + "px)"] = {
    alignItems: align !== undefined && align.xxl
  }, _ref2;
}, getSpacing, getDisplay);
GridRow.propTypes = {
  gutters: PropTypes.bool,
  align: PropTypes.shape({})
};
GridRow.defaultProps = {
  gutters: true,
  align: undefined
};
export default GridRow;